<template>
   <div>
       <b-modal centered no-close-on-backdrop ok-title="Xác nhận" ok-only hide-header @ok="submitAnswer(true)" button-size="sm" id="timeLimit">
           <h5>Đã hết thời gian làm bài. Bấm xác nhận để  nộp bài</h5>
       </b-modal>
       <b-modal centered no-close-on-backdrop size="lg" ok-title="Xác nhận" hide-footer hide-header @ok="submitAnswer(true)" button-size="sm" id="noAnswerYet">
           <div class="modal-border d-flex p-4">
               <img class="chacter" src="../../assets/popup-chacter.png" alt="">
               <div class="message-block text-center">
                   <p class="m-0">Vẫn còn câu hỏi chưa hoàn thành,</p>
                   <p class="m-0">Bạn nhỏ có muốn chuyển sang câu hỏi tiếp theo không?</p>
                   <div class="button-block d-flex p-2">
                       <div class="button-item">
                           <button @click="submitAnswer" class="border-0 bg-transparent"><img src="../../assets/btn-yes.png" alt="" class="mw-100"></button>
                       </div>
                       <div class="button-item">
                           <button @click="hideModal('noAnswerYet')" class="border-0 bg-transparent"><img src="../../assets/btn-no.png" alt="" class="mw-100"></button>
                       </div>
                   </div>
               </div>
           </div>
       </b-modal>
        <div class="card-header">
            <p class="title-line1">{{ sectionName }}</p>
        </div>
        <div class="card-body topofpanel">
            <div action="" class="info-submit m-auto text-center">
                <div class="panel-tutorial">
                    <div class="part-info">
                        <div class="part-audio">
                            <div class="" v-if="isAudio" >
                                <div class="w-100 d-flex align-items-center justify-content-between" >
                                    <div class="audio-control">
                                        <button :disabled="audioReplayTime == 0" @click="playPauseAudio" class="play border-0 bg-transparent d-flex">
                                            <svg fill="currentColor" height="33" v-if="!isAudioPlay" viewBox="0 0 512 512"><path d="M176 480C148.615 480 128 457.608 128 432V80C128 54.62 148.396 32.017 176.012 32.017C184.698 32.017 193.366 34.368 201.031 39.047L489.031 215.047C503.297 223.766 512 239.281 512 256S503.297 288.234 489.031 296.953L201.031 472.953C193.359 477.641 184.688 480 176 480Z" class="fa-secondary"/></svg>
                                            <svg fill="currentColor" height="33" v-if="isAudioPlay" viewBox="0 0 320 512"><path d="M272 64C245.49 64 224 85.49 224 112V400C224 426.51 245.49 448 272 448S320 426.51 320 400V112C320 85.49 298.51 64 272 64ZM48 64C21.49 64 0 85.49 0 112V400C0 426.51 21.49 448 48 448S96 426.51 96 400V112C96 85.49 74.51 64 48 64Z" class="fa-secondary"/></svg>
                                            <!-- {{ audioReplayTime }} -->
                                        </button>
                                    </div>
                                    <div class="audio-timerange">
                                        <div class="time-line" @click="audioGoto($event)">
                                            <div class="time-duration" :style="{width: `${audioTimeProcess}px`}"></div>
                                        </div>
                                        <span class="time">{{ this.formatSecondsAsTime(audioCurrentTime) }} / {{ this.formatSecondsAsTime(audioDuration) }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="part-time">
                            <div>
                                <p class="m-0">Thời gian: <span>{{ formatSecondsAsTime(this.examTime)}}</span></p>
                            </div>
                        </div>
                        <audio ref="audiocontrol" id="audio" autoplay="true" controlsList="nodownload" class="mr-1">
                            <source :src="audioSrc" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="question-block">
                        <h4 class="question-title ql-editor" v-html="questionTitle"></h4>
                        <component class="question-main mt-5" :is="pageChooseType" v-model="resultData[pageSelected]" :qdata="pageData" :key="pageSelected"></component>
                    </div>
                </div>
                <button @click="nextQuestion" class="mt-5 m-auto border-0 bg-transparent">
                    <img class="mw-100" src="../../assets/newyear/chuyentiep.png" alt="">
                </button>
            </div>
        </div>
   </div>
</template>

<script>

import {
    BModal
} from 'bootstrap-vue'

import lt_choose from '@/components/slide_type/LtChoose.vue';
import lt_fill from '@/components/slide_type/LtFill.vue';
import lt_detail from '@/components/slide_type/LtDetail.vue';
import rw_arrange_letters from '@/components/slide_type/RwArrangeLetters.vue'
import rw_determine_right_wrong from '@/components/slide_type/RwDetermineRightWrong.vue'
import rw_choose_corect_answer from '@/components/slide_type/RwChooseCorectAnswer.vue'
import rw_choose_corect_answer2 from '@/components/slide_type/RwChooseCorectAnswer2.vue'
import rw_complete_story from '@/components/slide_type/RwCompleteStory.vue'
import rw_complete_story2 from '@/components/slide_type/RwCompleteStory2.vue'
import rw_complete_story3 from '@/components/slide_type/RwCompleteStory3.vue'

export default {
    data() {
        return {
            pageSelected: 0,
            pageChooseType: '',
            audioControl: null,
            audioDuration: 0,
            audioCurrentTime: 0,
            audioReplayCounter: 0,
            timeDurationWidth: 0,
            timeCurrentWidth: 0,
            isAudioPlay: false,
            resultData: [],
            downTimeState: false,
            timeIntervalEvent: null,
            partName: [
                { title: 'Listening' },
                { title: 'Reading & writing' },
            ],
            part: 0,
            partTimeDuration: [
                600,
                900
            ]
        }
    },
    components: {
        BModal,
        lt_choose,
        lt_fill,
        lt_detail,
        rw_arrange_letters,
        rw_determine_right_wrong,
        rw_choose_corect_answer,
        rw_complete_story,
        rw_choose_corect_answer2,
        rw_complete_story2,
        rw_complete_story3,
    },
    mounted () {
        this.audioControl = document.querySelector('#audio');
        this.audioControl.addEventListener('canplay', (event) => {
            this.audioDuration = event.target.duration
            
            this.timeDurationWidth = document.querySelector('.audio-timerange').clientWidth
        })

        this.audioControl.addEventListener('timeupdate', (event) => {
            this.audioDuration = event.target.duration
            this.audioCurrentTime = event.target.currentTime
        })

        this.audioControl.addEventListener('ended', () => {
            this.audioCurrentTime = 0;
            this.audioReplayCounter++;
        })

        this.audioControl.addEventListener('pause', () => {
            this.isAudioPlay = false
        })

        this.audioControl.addEventListener('play', () => {
            this.isAudioPlay = true
        })

        this.timeIntervalEvent = setInterval(()=> {
            if (this.downTimeState) {
                this.examTime -= 1;
            }
        }, 1000)

    },
    destroyed() {
        clearInterval(this.timeIntervalEvent)
    },
    created() {
        console.log(this.testHistory)
        if (this.testHistory.test_result) {
            this.$store.commit('SET_EXAM_TIME', this.testHistory.test_result.examTime)
            this.resultData = this.testHistory.test_result.answers
            this.pageChoose(this.testHistory.test_result.questionCurrent)
            this.downTimeState = true

        } else {
            this.getQuestion()
        }
    },
    computed: {
        audioReplayTime () {
            return this.audioReplay - this.audioReplayCounter
        },
        testHistory() {
            return this.$store.state.testHistoryData
        },
        examTime: {
            get () {
                return this.$store.state.examTime
            },
            set (value) {
                this.$store.commit('SET_EXAM_TIME', value)
            }
        },
        isAudio() {
            return this.examData[this.pageSelected]?.data?.audio1
        },
        audioReplay() {
            return this.examData[this.pageSelected]?.data?.audio1?.data?.audio_replay || 0
        },
        audioSrc() {
            return this.examData[this.pageSelected]?.data?.audio1?.data?.src
        },
        questionTitle () {
            return this.examData[this.pageSelected]?.data?.label1?.data?.value || ''
        },
        pageData () {
            return this.examData[this.pageSelected]?.data
        },
        audioTimeProcess () {
            const ratioElement = this.timeDurationWidth / 100;
            const ratioAudio = this.audioCurrentTime / this.audioDuration * 100;
            return ratioElement * ratioAudio
        },
        examData () {
            return this.$store.state.examData
        },
        examId () {
            return this.$store.state.examId
        },
        sectionName () {
            return this.$store.state.sectionName
        },
    },
    watch: {
        examTime (value) {
            // console.log(this.part)
            if (value <= 0) {
                
                if (this.part == 1) {// neu dang o part reading
                    this.downTimeState = false
                    this.$bvModal.show('timeLimit')
                }

                if (this.part == 0) { // Neu dang o part listening
                    this.part = 1
                    this.examTime = this.partTimeDuration[value]

                    const findIndexPart = this.examData.findIndex(el => {
                        return this.questionTypeToSectionName(el.id) == 1
                    })

                    if (findIndexPart) {
                        this.pageChoose(findIndexPart)
                    }
                }
                
            }
        },
        part (value, oldValue) {
            if (value != oldValue) {
                this.examTime = this.partTimeDuration[value]
            }
        }
    },
    methods: {
        hideModal(modalId) {
            this.$bvModal.hide(modalId)
        },
        updateTime () {
            const trackid = localStorage.getItem('_speakup_track');

            this.$http.post('/test-push-info', {
                tracking_id: trackid,
                test_id: localStorage.getItem(`_speakup_exam${this.examId}`),
                data: {
                    examTime: this.examTime
                }
            }).then(res => {
                console.log('time update: ', res.data.code)
            })
        },
        questionTypeToSectionName (type) {
            if (!type) { return -1 }
            let partType = 0
            switch (type) {
                case 'lt_choose':
                case 'lt_fill':
                case 'lt_detail':
                    partType = 0
                    break;
                case 'rw_arrange_letters':
                case 'rw_determine_right_wrong':
                case 'rw_choose_corect_answer2':
                case 'rw_complete_story2':
                case 'rw_complete_story3':
                    partType = 1
                    break;
                default:
                    break;
            }
            return partType;
        },

        /* eslint-disable no-unused-vars */
        audioGoto(event) {

            // giới hạn số lượt replay
            // nên không cho đặt mốc thời gian play


            // if (this.isAudio) {
            //     const radioAudio = this.audioDuration / 100;
            //     const radioElement = event.offsetX / this.timeDurationWidth * 100;

            //     this.audioControl.currentTime = radioAudio * radioElement

            //     this.playPauseAudio()
            // }
        },
        /* eslint-disable no-unused-vars */

        formatSecondsAsTime(secs) {
            var hr  = Math.floor(secs / 3600);
            var min = Math.floor((secs - (hr * 3600))/60);
            var sec = Math.floor(secs - (hr * 3600) -  (min * 60));

            if (min < 10){ 
                min = "0" + min; 
            }
            if (sec < 10){ 
                sec  = "0" + sec;
            }
            return min + ':' + sec;
        },
        audioInit () {
            if (this.isAudio) {
                this.audioControl.load()
            }
        },
        playPauseAudio() {
            if (this.audioControl && this.audioReplayTime > 0) {
                if (this.audioControl.paused)
                this.audioControl.play()
                else
                this.audioControl.pause()
            }
        },
        createHistory () {
            const trackid = localStorage.getItem('_speakup_track');
            if (trackid) {
                this.$http.post('/test-create', {
                    tracking_id: trackid,
                    exam_id: this.examId
                }).then(res => {
                    if (res.data.code == 1) {
                        this.downTimeState = true
                        localStorage.setItem(`_speakup_exam${this.examId}`, res.data.data);
                    } else {
                        this.$bvToast.toast(res.data.message, {
                            title: `Có lỗi xảy ra !`,
                            variant: 'danger',
                            solid: true
                        })
                    }
                })
            }
        },
        getQuestion () {
            console.log(this.examData)
            for (let index = 0; index < this.examData.length; index++) {
                this.resultData[index] = {
                    answers: null,
                    type: this.examData[index].id
                }
            }
            this.pageChoose(0)

            this.createHistory()
        },
        nextQuestion() {

            if (this.resultData[this.pageSelected].answers == null) {
                this.$bvModal.show('noAnswerYet')
            } else {

                if (typeof this.resultData[this.pageSelected].answers == 'object') {
                    for (let index = 0; index < this.resultData[this.pageSelected].answers.length; index++) {
                        const element = this.resultData[this.pageSelected].answers[index];
                        if (element == null) {
                            this.$bvModal.show('noAnswerYet')
                            return;
                        }
                    }
                    this.submitAnswer()
                    return;
                } else {
                    this.submitAnswer()
                }
            }


            // const nextPage = this.pageSelected + 1
            // if (nextPage < this.examData.length) {
            //     this.pageChoose(nextPage)
            // }

        },
        submitAnswer (status = false) {
            this.hideModal('noAnswerYet');
            this.downTimeState = false
            // const trackid = localStorage.getItem('_speakup_track')
            const testHistory = localStorage.getItem(`_speakup_exam${this.examId}`)
            const nextPage = this.pageSelected + 1
            
            this.$http.post('/test-save-v2',{
                test_id: testHistory,
                test_data: {
                    answers: this.resultData,
                    questionCount: this.examData.length,
                    questionCurrent: nextPage,
                    part: this.part,
                    examTime: this.examTime
                },
                type: 'slide',
                status
            })
            .then(res => {
                if (res.data.code === 1) {
                    if (nextPage == this.examData.length || this.examTime == 0) {
                        this.$store.commit('SET_PAGE', 4)
                    } else {
                        this.pageChoose(nextPage)
                    }

                    if (this.examTime > 0) {
                        this.downTimeState = true
                    }
                    
                } else {
                    this.$bvToast.toast(res.data.message, {
                        title: `Có lỗi xảy ra !`,
                        variant: 'danger',
                        solid: true
                    })
                }
            })
        },
        pageChoose(index) {

            // Đặt lại giới hạn nghe audio mỗi lần chuyển trang
            this.audioReplayCounter = 0;

            // index = 0;
            const self = this;
            this.pageChooseType = '';
            
            if (index >= self.examData.length -1) {
                self.pageSelected = self.examData.length - 1
            } else {
                self.pageSelected = index
            }
            
            if (self.pageSelected >= 0 && self.pageSelected <= self.examData.length - 1) {
                self.pageChooseType = self.examData[self.pageSelected].id
            }

            // if (!this.resultData[self.pageSelected]) {
            //     this.resultData[self.pageSelected] = {
            //         answer: null,
            //         type: self.examData[self.pageSelected].id
            //     }
            // }

            if (this.audioControl) {
                if (!this.audioControl.paused)
                this.audioControl.pause()
            }

            this.$store.commit('PAGE_PROCESS', {
                questionCount: self.examData.length,
                questionCurrent: self.pageSelected + 1
            })

            this.$nextTick(function () {
                this.audioInit()

                this.$nextTick(()=>{
                    setTimeout(() => {
                        window.scrollTo(0, document.querySelector('.topofpanel').getBoundingClientRect().y + window.scrollY - 50);
                    }, 100)
                })
            })

            this.part = this.questionTypeToSectionName(this.pageChooseType)
            this.$store.commit('SET_SECTION_NAME', this.partName[this.part].title)
        },
    }
}
</script>

<style scoped>

ul {
    list-style: decimal-leading-zero;
    text-align: left
}

ul li {
    margin-bottom: 25px;
    font-family: 'Roboto-Medium';
    font-size: 1.5rem;
}

ul li::marker {
    color: #0d5fcb;
    font-family: 'iCiel Crocante';
}

.title-line1 {
    font-family: 'iCiel Crocante';
    font-size: 2.5rem;
    color: #fc7b32;
}

.panel-tutorial h3 {
    color: #0099ff;
    font-size: 2rem;
    font-family: 'iCiel Crocante';
}

.panel-tutorial {
    padding: 50px;
    border-radius: 35px;
    border: 3px solid #0099ff;
    background-color: #fff;
    position: relative;
    margin-top: 80px;
}

.part-audio {
    width: 45%;
}

.part-audio>div {
    position: relative;
    background-color: #ffcd04;
    border: 2px solid #ff8717;
    border-radius: 30px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
}

.audio-timerange {
    width: 80%;
    text-align: left;
    color: #af275a;
    font-size: 0.8rem;
    font-family: 'Roboto-Medium';
}

.audio-timerange .time {
    margin-top: 2px;
    display: block;
}

.audio-timerange .time-line {
    position: relative;
    height: 12px;
    background-color: #af275a;
    width: 100%;
    border-radius: 20px;
    border: 1px solid #fff;
    cursor: pointer;
}

.time-duration {
    position: absolute;
    height: 10px;
    background: linear-gradient(0deg, rgba(246,160,13,1) 0%, rgba(243,255,1,1) 50%, rgba(246,160,13,1) 100%);
    border-radius: 20px;
}

.time-duration:after {
    content: '';
    height: 14px;
    width: 10px;
    display: block;
    background-color: #fff;
    border-radius: 7px;
    border: 1px solid #af275a;
    top: -2px;
    position: absolute;
    right: -5px;
    cursor: pointer;
}

.part-info {
    position: absolute;
    width: 100%;
    top: -44px;
    padding: 0px 60px;
    left: 0px;
    display: flex;
    justify-content: space-between;
}


.part-time>div span {
    color: #fff;
}

.part-time {
    width: 30%;
}

.part-time>div {
    border-radius: 30px;
    font-family: 'Nunito', sans-serif;;
    font-size: 1.7rem;
    color: #fff;
    background-color: #1ebcff;
    position: relative;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #64d1ff;
}

.question-block {
    margin-top: 50px;
}
.question-title {
    font-family: 'FS Ariston Comic Base';
    color: #4cac33;
    font-size: 2.5rem;
    line-height: 2rem;
}

@media (max-width: 990px) {
    .panel-tutorial {
        padding: 20px;
    }
}

@media (max-width: 768px) {
    .title-line1 {
        font-size: 1.8rem;
    }

    .part-info {
        flex-direction: column;
        top: -40px;
    }

    .part-info .part-audio {
        width: 100%;
    }

    .part-info .part-time {
        width: fit-content;
        order: -1;
        margin:auto;
        margin-bottom: 20px;
    }

    .question-block {
        margin-top: 140px;
    }

    #noAnswerYet .message-block p {
        font-size: 1.3rem;
    }

    #noAnswerYet .button-block .button-item {
        padding: 10px 10px;
    }
}


</style>

<style>
.section-title {
    font-family: 'FS Ariston Comic Base';
    color: #e35707;
    font-size: 2.5rem;
}

#noAnswerYet .modal-body {
    padding: 0;
}

#noAnswerYet .modal-content {
    border: 16px solid #ffa800;
    border-radius: 20px;
    -moz-box-shadow: inset 3px 3px 4px #ff860f;
    -webkit-box-shadow: inset 3px 3px 4px #ff860f;
    box-shadow: inset 3px 3px 4px #ff860f;
    background: url(../../assets/bg-modal.png);
    background-position: center bottom;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #fff3d5;
}

#noAnswerYet .chacter {
    max-width: 25%;
    height: 100%;
    margin: auto 0px 10px 30px;
}

#noAnswerYet .message-block p {
    font-family: 'iCiel Crocante';
    font-size: 1.7rem;
    color: #ff5c00;
}

#noAnswerYet .message-block p:nth-child(2) {
    color: #0781ff;
}

#noAnswerYet .button-block .button-item {
    padding: 20px 34px;
}


.audio-control .play {
    color: #af275a;
}

.audio-control .play[disabled] {
    color: #a3617a;
}

</style>